import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../auth/auth.service';
import { ModuleService } from '../../../resources/module/module.service';
import { SubmoduleService } from '../../../resources/submodule/submodule.service';
import { ElementService } from '../../../resources/element/element.service';
import { ScrollToService } from '../../../utilities/scroll-to/scroll-to.service';
import { ToastService } from '../../../services/toast/toast.service';
import { TranslateService } from '../../../utilities/translate/translate.service';

@Component({
  selector: 'sg2-project-info-button-add',
  templateUrl: './project-info-button-add.component.html',
  styleUrls: ['./project-info-button-add.component.less']
})
export class ProjectInfoButtonAddComponent implements OnInit {

  constructor(
    public authService: AuthService,
    private elementService: ElementService,
    private moduleService: ModuleService,
    private submoduleService: SubmoduleService,
    private scrollToService: ScrollToService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
  }

  /**
   * Add module.
   *
   * @todo Toast should be added to ModuleService.add(), but that can cause problems due to
   *  Material Snackbar not supporting stacked toasts.
   */
  public addModule(): void {
    this.moduleService.add().subscribe(module => {
      this.submoduleService.add(module).subscribe(submodule => {
        this.elementService.addParagraph(submodule).subscribe(element => {
          this.toastService.open(this.translateService.get('moduleAdded'));
          this.scrollToService.find(element._id, { animate: 'flash' });
        });
      });
    });
  }

  // Toon modal met 1 optie (module)
  public addSubmodule() { }

  // Toon modal met 2 opties (module, submodule)
  public addElement() { }
}
